import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon, Popover, Select, Tooltip, Modal } from 'antd';
import { Link } from 'dva/router';

import { UserRole } from 'utils/enums';

import Menus from './Menu';
import NotificationBadge from './NotificationBadge';

import styles from './Header.less';

const SubMenu = Menu.SubMenu;
const Option = Select.Option;
const confirm = Modal.confirm;

const Header = ({
  user, logout, switchSider, siderFold, isNavbar, menuPopoverVisible, location, switchMenuPopover,
  navOpenKeys, changeOpenKeys, menu, accountingPeriod, selectPeriod, beginPeriod,
}) => {
  const handleClickMenu = (e) => {
    switch (e.key) {
      case 'logout':
        logout();
        break;
      case 'change':
        // window.location = `${configs.frontSiteUrl}/list-spaces`;
        break;
      default:
        break;
    }
  };
  const handleSelectPeriod = (year) => {
    confirm({
      title: `Bạn có muốn chuyển sang dữ liệu kế toán năm ${year}?`,
      onOk() {
        selectPeriod(parseInt(year));
      },
    });
  };
  const menusProps = {
    menu,
    siderFold: false,
    darkTheme: false,
    isNavbar,
    handleClickNavMenu: switchMenuPopover,
    location,
    navOpenKeys,
    changeOpenKeys,
  };

  const periodOptions = [];
  for (let period = beginPeriod; period <= (new Date()).getFullYear(); period += 1) {
    periodOptions.push(<Option value={period} key={period}>{period}</Option>);
  }

  let className = '';
  if (user.userRole === UserRole.ACCOUNTING) className = 'text-info';
  else if (user.userRole === UserRole.MANAGEMENT) className = 'text-warning';

  return (
    <div className={styles.header}>
      {isNavbar ?
        (
          <Popover
            placement="bottomLeft"
            onVisibleChange={switchMenuPopover}
            visible={menuPopoverVisible}
            overlayClassName={styles.popovermenu}
            trigger="click"
            content={<div style={{ maxHeight: `${document.body.clientHeight - 47}px`, overflowY: 'auto' }}><Menus {...menusProps} /></div>}
          >
            <div className={styles.button}>
              <Icon type="bars" />
            </div>
          </Popover>
        )
        :
        (
          <div className={styles.button} onClick={switchSider}>
            <Icon type={siderFold ? 'menu-unfold' : 'menu-fold'} />
          </div>
        )
      }
      <div className={styles.rightWarpper}>
        <Tooltip placement="left" title="Chọn kỳ kế toán">
          <div className={styles.select}>
            <div id="selectYear">
              <Select value={accountingPeriod} style={{ width: 70 }} onChange={handleSelectPeriod}>
                {periodOptions}
              </Select>
            </div>
          </div>
        </Tooltip>

        <NotificationBadge className={styles.button} />

        <Menu mode="horizontal" className={styles.rightMenu} onClick={handleClickMenu}>
          <SubMenu title={<span className={className} > <Icon type="user" />{user.displayName} </span>}>
            <Menu.Item key="change">
              <Link to="/space">Chuyển sổ </Link>
            </Menu.Item>

            {(user.userRole !== UserRole.READONLY && (user.appRole === UserRole.ADMINISTRATOR || user.appRole === UserRole.ACCOUNTANT || user.appRole === UserRole.MANAGER)) &&
              <Menu.Item key="report">
                <Link to="/space/report">Báo cáo thuế</Link>
              </Menu.Item>
            }

            <Menu.Item key="password">
              <a href="https://id.1ketoan.com/password" target="_blank" rel="noopener noreferrer"> Đổi mật khẩu </a>
            </Menu.Item>
            <Menu.Item key="logout">
              Đăng xuất
            </Menu.Item>
          </SubMenu>
        </Menu>
      </div>
    </div>
  );
};

Header.propTypes = {
  menu: PropTypes.array,
  user: PropTypes.object,
  logout: PropTypes.func,
  switchSider: PropTypes.func,
  siderFold: PropTypes.bool,
  isNavbar: PropTypes.bool,
  menuPopoverVisible: PropTypes.bool,
  location: PropTypes.object,
  switchMenuPopover: PropTypes.func,
  navOpenKeys: PropTypes.array,
  changeOpenKeys: PropTypes.func,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Layout/Header.js